module.exports = "/_next/static/images/saturn-cd6342f223f6f5a118db9c152591c1ef.png";